import React, { useState, useRef, useEffect } from "react";
import EnqueryData from "./EnqueryData";
import LeadsOrders from "./LeadsOrders";
import { Link } from "react-router-dom";
import Cateringscrollingorder from "./Cateringscrollingorder";
import Cateringpackagesorders from "./Cateringpackagesorders";

function Cateringordersdata() {
    const [activeTab, setActiveTab] = useState("first"); // default tab
    const isMobile = window.innerWidth <= 768;

    const [isPaused, setIsPaused] = useState(false);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };
    const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
    const scrollRef = useRef(null);
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        let scrollInterval;

        if (scrollContainer && !isPaused) {
            scrollInterval = setInterval(() => {
                if (
                    scrollContainer.scrollTop + scrollContainer.clientHeight >=
                    scrollContainer.scrollHeight
                ) {
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll speed
                }
            }, 50);
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]); // pause state control karega


    const getOfferColor = (type) => {
        switch (type) {
            case "buffet":
                return "#ff6f61";
            case "wedding":
                return "#6a5acd";
            case "birthday":
                return "#ffb347";
            case "corporate":
                return "#2e8b57";
            default:
                return "#333";
        }
    };

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "947px",
                margin: '150px 230px',
                marginTop: "150px",
                fontFamily: "Arial, sans-serif",
            }}
        >
            <p
                className="breadcrumb maamaas-home-bredcum"
                style={{
                    position: "fixed",
                    top: isMobile ? "50px" : "62px",
                    left: isMobile ? "5px" : "255px",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    padding: "28px 0",
                    fontSize: isMobile ? "14px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                    height: "60px"
                }}
            >
                <Link
                    to="/Newmainlandingpage"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>
                <span className="separator"> &gt; </span>
                <Link

                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Order_Management
                </Link>
                <span className="separator"> &gt; </span>
                <Link

                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Catering & Services
                </Link>


            </p>
            {/* Tabs Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                    marginTop: "0px"
                }}
            >
                <button
                    onClick={() => setActiveTab("first")}
                    style={{
                        padding: "10px 20px",
                        cursor: "pointer",
                        border: "1px solid rgb(177 93 198)",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        backgroundColor: activeTab === "first" ? "rgb(177 93 198)" : "white",
                        color: activeTab === "first" ? "white" : "rgb(177 93 198)",
                        transition: "0.3s",
                    }}
                >
                    Status
                </button>

                <button
                    onClick={() => setActiveTab("third")}
                    style={{
                        padding: "10px 20px",
                        cursor: "pointer",
                        border: "1px solid rgb(177 93 198)",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        backgroundColor: activeTab === "third" ? "rgb(177 93 198)" : "white",
                        color: activeTab === "third" ? "white" : "rgb(177 93 198)",
                        transition: "0.3s",
                    }}
                >
                    Reports
                </button>
            </div>

            {/* Tabs Content third */}
            <div

            >
                {activeTab === "first" && <LeadsOrders />}
                {/* {activeTab === "second" && <Catreingleads />} */}
                {activeTab === "third" && <Cateringpackagesorders />}
            </div>


            <div>
                <Cateringscrollingorder />
            </div>
        </div>




    );
}

export default Cateringordersdata;
